module.exports = __webpack_public_path__ + "img/607.65085322.jpg";